function Attendance({ attending, name = 'attendance', onChange }) {
  return (
    <div className="content">
      <h2 className="josefin-slab upper">Attendance</h2>

      <p className="josefin-slab">
        Thank you so much for visiting our wedding website.
        <br/><br/>
        We truly hope you&apos;ll be able to join us as we say &ldquo;I will!&rdquo;.
        <br/><br/>
        If you have any questions before then, feel free to reach out to us directly.
      </p>

      <div className="rsvp-options rsvp-options-two-col">
        <label className="josefin-slab rsvp-label">
          <input type="radio" name={name} value="attending" required onChange={() => onChange(true)} checked={attending === true} />
          Accepts with pleasure
        </label>
        <label className="josefin-slab rsvp-label">
          <input type="radio" name={name} value="not-attending" required onChange={() => onChange(false)} checked={attending === false} />
          Declines with regret
        </label>
      </div>
    </div>
  );
}

export default Attendance;
